import './SharedChartInteractions.css';
export var containerSVG = '_1kxqsb60-2-0-1';